import Profile from '../profile/Profile';

export default function AdminProfile() {
  return <Profile />;
}